module.exports = __webpack_public_path__ + "img/heart2.fac39d1b.png";